import { Autocomplete, Container, DialogActions, DialogContent, DialogTitle, Grid, Icon, TextField } from '@mui/material';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import { useSnackbarCustom } from 'hooks/useSnackCustom';
import HeaderOuBannerDependendoDaInterpretacaoH1 from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import useTabelaPreco from 'layout/topbar/tabela-preco';
import { IAbstractModel } from 'model/abstract.model';
import { useCallback, useEffect, useRef, useState } from 'react';
import { setTabelaPreco } from 'redux/features/configuracoes';
import { atualizaValoresItensPedido } from 'redux/features/stateSlice';
import { useAppDispatch, useAppSelector } from 'redux/hooks';

import ConfirmacaoExcluirSkuDialog, { DialogConfirmacaoExcluirSku } from './confirmacao-excluir-sku-dialog';
import useCustomLocation from 'utils/useCustomLocation';
import { SituacaoConsignado } from 'pages/consignado/situacao-consignado.model';
import { atualizaValoresItensConsignado, setTabelaPrecoConsignado } from 'redux/features/consignadoSlice';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const initialState: DialogConfirmacaoExcluirSku = {
  data: [],
  length: 0,
  produtosParaExcluir: [],
  showConfirmaExclusao: false,
  tabelaPrecoTemp: null
};

const TabelaPrecoPreferenciaDialog = (props: Props) => {

  const preferencias = useAppSelector(s => s.preferencias);
  const tabelaPrecoPedido = useAppSelector(s => s.configuracoes.configuracaoPedidoBalcao.tabelaPreco);
  const itens = useAppSelector(s => s.state.pedido.itens);
  const itensTroca = useAppSelector(s => s.state.pedido.itensTroca);
  const { tableData, tabelaPreco: tabelaConsignado } = useAppSelector(s => s.consignado);
  const { isTelaRegistraConsignado, isTelaDevolucaoConsignado } = useCustomLocation();

  const { dadosAlterarTabelaPrecoState, setDadosAlterarTabelaPrecoState, atualizarOuRemoverItensPedido } = useTabelaPreco();

  const isTelasConsignado = ()=> {
    return isTelaRegistraConsignado() || isTelaDevolucaoConsignado()
  }

  const getTabelaPrecoAtual = () => {
    if(isTelasConsignado()) {
      return tabelaConsignado;
    }
    return tabelaPrecoPedido;
  }

  const dispatch = useAppDispatch();
  const { addError } = useSnackbarCustom();
  const tabelaPrecoIptRef = useRef<HTMLInputElement>(null);
  const [tabelaSelecionada, setTabelaSelecionada] = useState<IAbstractModel | null>(null);
  const [filtro, setFiltro] = useState('');
  const tabelaAtualRef = useRef<IAbstractModel | null>(getTabelaPrecoAtual());

  const getItensToUse = () => {
    return isTelasConsignado() ? tableData[SituacaoConsignado.ABERTO] : [...itens, itensTroca];
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const onCloseModalSkus = () => {
    setDadosAlterarTabelaPrecoState(prevState => ({
      ...prevState,
      data: initialState.data,
      length: initialState.length,
      produtosParaExcluir: initialState.produtosParaExcluir,
      showConfirmaExclusao: initialState.showConfirmaExclusao,
      tabelaPrecoTemp: initialState.tabelaPrecoTemp
    }));
  };

  const atualizaTabelaPreco = useCallback((tabelaPreco: IAbstractModel) => {
    if (isTelasConsignado()) {
      dispatch(setTabelaPrecoConsignado(tabelaPreco));
    } else {
      dispatch(setTabelaPreco(tabelaPreco));
    }
    //eslint-disable-next-line
  }, [isTelasConsignado()]);

  const onConfirmModalSkus = () => {

    if (isTelasConsignado()) {
      dispatch(atualizaValoresItensConsignado(dadosAlterarTabelaPrecoState.data));
    } else {
      dispatch(atualizaValoresItensPedido(dadosAlterarTabelaPrecoState.data));
    }
    if (dadosAlterarTabelaPrecoState.tabelaPrecoTemp) {
      atualizaTabelaPreco(dadosAlterarTabelaPrecoState.tabelaPrecoTemp);
    }
    onCloseModalSkus();
  };

  useEffect(() => {
    const tabelaToUse = getTabelaPrecoAtual();
    const current = tabelaAtualRef.current;
    if (!!tabelaToUse && current?.uuid !== tabelaToUse.uuid && (!!getItensToUse().length)) {
      tabelaAtualRef.current = tabelaToUse;
      atualizarOuRemoverItensPedido(tabelaToUse);
    } else {
      tabelaAtualRef.current = tabelaToUse;
    }

    //eslint-disable-next-line
  }, [getTabelaPrecoAtual()]);

  const handleConfirm = () => {
    if (!tabelaSelecionada) return addError({ message: 'Selecione uma tabela de preço.', closeable: true });

    atualizarOuRemoverItensPedido(tabelaSelecionada);

    handleClose();
  };

  useEffect(() => {
    setTabelaSelecionada(null);
    setFiltro('');
    if (props.open) {
      resetFocus();
    }
    //eslint-disable-next-line
  }, [props.open]);

  const resetFocus = () => {
    setTimeout(() => {
      tabelaPrecoIptRef.current?.focus();
    },);
  };

  const filterTabelaPrecoPreferencial = useCallback((options: IAbstractModel[]) => {
    if (!filtro) return options;
    return options.filter(e => e.descritivo.toUpperCase().includes(filtro.toUpperCase()));
  }, [filtro]);

  const onInputChange = useCallback((event: any, value: string) => {
    setFiltro(value);
  }, []);


  const onSetTabelaPrecoPreferencial = useCallback((value: IAbstractModel | null) => {
    setTabelaSelecionada(value);
  }, []);

  const onClose = (_: unknown, reason: unknown) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
  };

  return (
    <>
      {props.open && <CustomDialog
        open={props.open}
        fullWidth
        onClose={onClose}
        maxWidth={'sm'}
        hideCloseButton
      >

        <DialogTitle style={{ textAlign: "center" }}>
          <HeaderOuBannerDependendoDaInterpretacaoH1
            id='tabela-preco-preferencial-dialog-title'
            iconClassName='fa-solid fa-right-left'
            label='Tabela de Preço Preferencial'
            small
          />
        </DialogTitle>

        <DialogContent
          sx={{
            overflowX: 'hidden',
            paddingTop: '2px !important',
          }}
        >
          <Container maxWidth="xl">
            <Grid item xs={12} sm={6} lg={12}>
              <Autocomplete
                value={tabelaSelecionada}
                id="acTabelaPrecoPreferencial"
                options={filterTabelaPrecoPreferencial(preferencias.tabelasPreco ?? [])}
                getOptionLabel={(option) => option.descritivo}
                onInputChange={onInputChange}
                filterOptions={(x) => x}
                noOptionsText={'Nenhum resultado encontrado'}
                onChange={(_, value) => onSetTabelaPrecoPreferencial(value)}
                isOptionEqualToValue={(option, value) => { return option.uuid === value.uuid; }}
                openOnFocus
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.uuid}>
                      {option.descritivo}
                    </li>
                  );
                }}
                renderInput={
                  (params) => <TextField {...params}
                    label="Tabela de preço preferencial"
                    variant="standard"
                    inputRef={tabelaPrecoIptRef}
                    InputLabelProps={{
                      sx: {
                        marginLeft: '5px'
                      }
                    }}
                  />}
              />
            </Grid>
          </Container>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: 'center'
          }}>
          <CustomButton onClick={handleConfirm} id="confirm_button" type="submit" variant="contained" color="success" startIcon={<Icon className='fa-solid fa-check' />}>
            Confirmar
          </CustomButton>
        </DialogActions>
      </CustomDialog>}

      {dadosAlterarTabelaPrecoState.showConfirmaExclusao && (<ConfirmacaoExcluirSkuDialog
        open={dadosAlterarTabelaPrecoState.showConfirmaExclusao}
        dados={dadosAlterarTabelaPrecoState}
        onConfirm={onConfirmModalSkus}
      />)}
    </>);

};

export default TabelaPrecoPreferenciaDialog;
